





























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Meeting} from "@api/models/meetings/Meeting";
import {Element} from "@api/models/Element";
import {UserProfile} from "@api/models/UserProfile";
import {WebConferenceStateHelper} from "@share/web-conferences/helpers/WebConferenceStateHelper";
import AgoraConference from "@share/web-conferences/AgoraConference.vue";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import LiveKit from "@share/live-kit/LiveKit.vue";

@Component({
  name: "WebConference",
  components: {
      LiveKit,
      AgoraConference

  }
})
export default class WebConference extends Vue {
  @Prop({ required: true }) schemaId: string;
  @Prop({ required: true }) element: Meeting | Element;
  @Prop({ default: () => [] }) speakers: UserProfile[];
  @Prop({ default: false }) hideControlPanel: boolean;
  @Prop({ default: OnlineProvider.webConference }) onlineProvider: OnlineProvider;
  @Prop({ default: false }) showRecordingButton: boolean;

  // http://localhost:8080/app/476cc965-cec4-4e6f-9fae-5cae245b4944/session/db5f4431-6308-42c4-b16b-e05648124703/recording?sdata=uIn5n9xT2JtpCIx5Wh7KmS3sCv3330wjy8twQx3N1dWrHn6kUGM/eyxlQ9ao/M537ajuxsmrgvq00b+dm1YDY5UvHxAMlPf7Y8dm7xM26Qw=&skey=ac8eu79gl1prXijb
  //   http://localhost:8080/app/476cc965-cec4-4e6f-9fae-5cae245b4944/session/db5f4431-6308-42c4-b16b-e05648124703/recording?sdata=61ZOZspyTVvB0BfB41UyCdemPfE5rKt05YzY1aZC80Gl%2bh%2fJZUJfJfK1cVdy%2fWlegmaNhqXtUT%2fyfP5uAm252g%2bnoCWXjWHK4AJuodQvNUM%3d&skey=ScU16foqWQcqRie0
  stateHelper: WebConferenceStateHelper = new WebConferenceStateHelper();

  get isAgora()
  {
      return this.onlineProvider == OnlineProvider.webConference || this.onlineProvider == OnlineProvider.agora;
  }

  get isLiveKit() {
      return this.onlineProvider == OnlineProvider.liveKit;
  }

  get showLibrary() {
      //@todo get rid of any
      if (this.$refs['component']) {
          return (this.$refs['component'] as any).showLibrary || false;
      }

      return false;
  }
}
